// extracted by mini-css-extract-plugin
module.exports = {"project_resources_height":"ProjectResources_project_resources_height__2hKZc"};